// extracted by mini-css-extract-plugin
export var actionText = "_ny-4";
export var container = "_ny-0";
export var leftSection = "_ny-1";
export var rightSection = "_ny-2";
export var settingsButton = "_ny-6";
export var settingsIcon = "_ny-7";
export var shortcut = "_ny-5";
export var shortcutGroup = "_ny-3";